export const MAX_GLOSSARY_LABEL_LENGTH = 20;

export const glossaryLabelMaxLengthMessage = `Label must be ${MAX_GLOSSARY_LABEL_LENGTH} characters or less`;
